import { DateTime } from 'luxon';
import { Card } from '@Components/Card/index';
import LoadingSpinner from '@Components/LoadingSpinner';
import { Heading } from '@art-of-hospitality-solutions-llc/ui-kit/components/heading';
import { Separator } from '@art-of-hospitality-solutions-llc/ui-kit/components/separator';
import { formatPhone } from '@Utils/spendAmounts';
import { RED } from '../../../utils';
import { useFishDetails } from '../FishDetailsContext';

export default function TeamProfilePanel() {
  const { actor, employeeProfile, isLoading } = useFishDetails();

  return (
    <>
                <Card>
                  <div className="gap-12 px-4">
                    {isLoading ? (
                      <LoadingSpinner />
                    ) : (
                      <>
                        <div className="flex flex-col">
                          <div className="w-full pb-4">
                            <Separator className="bg-[#caab6a]" />
                            <Heading level={'h5'}>Contact Information</Heading>
                            <Separator className="bg-[#caab6a]" />
                          </div>

                          <div className="text-muted-foreground font-bold">
                            Name:
                          </div>
                          <div>
                            {employeeProfile?.fName +
                              ' ' +
                              employeeProfile?.lName}
                          </div>

                          <div className="text-muted-foreground pt-4 font-bold">
                            Email:
                          </div>
                          <div>{employeeProfile?.email || 'N/A'}</div>

                          <div className="text-muted-foreground pt-4 font-bold">
                            Phone Number
                          </div>
                          <div>
                            {formatPhone(actor?.phoneNumber)}
                          </div>

                          <div className="w-full pt-4">
                            <Separator className="bg-[#caab6a]" />
                            <Heading level={'h5'}>Address</Heading>
                            <Separator className="bg-[#caab6a]" />
                          </div>

                          <div className="text-muted-foreground pt-4 font-bold">
                            Address Line 1
                          </div>
                          <div>{employeeProfile?.addressLine1 || 'N/A'}</div>

                          <div className="text-muted-foreground pt-4 font-bold">
                            Address Line 2
                          </div>
                          <div>{employeeProfile?.addressLine2 || 'N/A'}</div>

                          <div className="text-muted-foreground pt-4 font-bold">
                            City
                          </div>
                          <div>{employeeProfile?.city || 'N/A'}</div>

                          <div className="text-muted-foreground pt-4 font-bold">
                            State
                          </div>
                          <div>{employeeProfile?.state || 'N/A'}</div>

                          <div className="text-muted-foreground pt-4 font-bold">
                            Country
                          </div>
                          {/*Using US as default country for now similar to membership*/}
                          <div>{employeeProfile?.country || 'US'}</div>

                          <div className="text-muted-foreground pt-4 font-bold">
                            Zip
                          </div>
                          <div>{employeeProfile?.zip || 'N/A'}</div>
                        </div>
                      </>
                    )}
                  </div>
                </Card>
                <Card className="p-8">
                  <div className="w-full">
                    <Separator className="bg-[#caab6a]" />
                    <Heading level={'h5'}>Social:</Heading>
                    <Separator className="bg-[#caab6a]" />
                  </div>
                  <div className="flex flex-col">
                    <div className="font-bold">LinkedIn:</div>
                    <div className="pb-4">
                      {employeeProfile?.social_LinkedIn || 'N/A'}
                    </div>

                    <div className="font-bold">Instagram:</div>
                    <div className="pb-4">
                      {employeeProfile?.social_Instagram || 'N/A'}
                    </div>

                    <div className="font-bold">TikTok:</div>
                    <div className="pb-4">
                      {employeeProfile?.social_TikTok || 'N/A'}
                    </div>

                    <div className="font-bold">YouTube:</div>
                    <div className="pb-4">
                      {employeeProfile?.social_YouTube || 'N/A'}
                    </div>
                  </div>
                </Card>
    </>
  );
}
